import React from "react";
import { cn } from "../../../lib/cn";

/**
 * WizardFooter — pie de un paso de wizard.
 *
 * Estructura típica:
 *   [slot izq]              "Paso X de Y"              [slot der]
 *
 * Los slots aceptan cualquier hijo: la lógica de qué botones mostrar
 * la decide la pantalla.
 */

export function WizardFooter({ step, total, left, right, className }) {
  return (
    <div
      className={cn(
        "border-t border-slate-100 px-6 py-4",
        "flex items-center justify-between gap-4",
        className
      )}
    >
      <div className="flex items-center gap-2 min-w-0">
        {left}
      </div>

      {typeof step === "number" && typeof total === "number" && (
        <div className="text-xs text-slate-500 tabular-nums shrink-0">
          Paso {step} de {total}
        </div>
      )}

      <div className="flex items-center gap-2 justify-end shrink-0">
        {right}
      </div>
    </div>
  );
}
